import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'login-root',
  templateUrl: './app.component.html',
  imports: [RouterModule],
})
export class AppComponent {
  year = new Date().getFullYear();
}
